import { render, staticRenderFns } from "./FormConjunto.vue?vue&type=template&id=1dfc5bbe&"
import script from "./FormConjunto.vue?vue&type=script&lang=js&"
export * from "./FormConjunto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports